// extracted by mini-css-extract-plugin
export var dark = "slideIndicators-module--dark--0f8a3";
export var light = "slideIndicators-module--light--0a4cf";
export var selectedIndicator = "slideIndicators-module--selectedIndicator--69453";
export var slideButton = "slideIndicators-module--slideButton--17d3a";
export var slideIndicator = "slideIndicators-module--slideIndicator--7cb1d";
export var slideIndicatorStyles = "slideIndicators-module--slideIndicatorStyles--88f25";
export var slideIndicators = "slideIndicators-module--slideIndicators--f7da3";
export var slideIndicatorsWrapper = "slideIndicators-module--slideIndicatorsWrapper--aa2bf";